export default __webpack_public_path__ + "static/media/Label_Trial_3.256918c5.svg";